<template>
	<v-app-bar id="default-app-bar" app absolute class="v-bar--underline" color="secondary" :clipped-left="$vuetify.rtl" :clipped-right="!$vuetify.rtl" height="70" flat>
		<v-toolbar-title>
			<a href="/">
				<img src="/logo-wide.png" style="float: right;max-width: 100px;max-height: 40px;" />
			</a>
			<strong class="mr-1 font-weight-black white--text">پنل اسپانسر و لیزینگ</strong>
			&nbsp;
			<user-business-name :hideCustomer="true" :options="{ textSizeClass: 'white--text text-h6' }" />
		</v-toolbar-title>

		<v-spacer />

		<default-settings />
		<!-- <default-search class="hidden-sm-and-down" /> -->

		<default-notifications />

		<default-account @profile="profile" />

		<v-dialog v-model="dialogUser" scrollable persistent max-width="1100px">
			<v-card>
				<v-card-title>
					<span class="headline">مشخصات کاربر</span>
					<v-spacer />
					<v-btn @click="dialogUser = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-profile ref="modifyProfile" :data="selectedUser" @callbck="callbck_userprofile" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-app-bar>
</template>

<script>
	// Utilities
	import { get, sync } from 'vuex-pathify'
	import ModifyProfile from '@/views/agent/ModifyProfile.vue'
	import UserBusinessName from '@/components/BusinessName'

	export default {
		name: 'DefaultBar',

		components: {
			UserBusinessName,
			DefaultAccount: () => import(
				/* webpackChunkName: "default-account" */
				'./widgets/Account'
			),
			DefaultDrawerToggle: () => import(
				/* webpackChunkName: "default-drawer-toggle" */
				'./widgets/DrawerToggle'
			),
			DefaultNotifications: () => import(
				/* webpackChunkName: "default-notifications" */
				'./widgets/Notifications'
			),
			DefaultSearch: () => import(
				/* webpackChunkName: "default-search" */
				'./widgets/Search'
			),
			DefaultSettings: () => import(
				/* webpackChunkName: "default-settings" */
				'./Settings'
			),
			'modify-profile': ModifyProfile,
		},
		data() {
			return {
				selectedUser: {},
				dialogUser: false,
			}
		},

		computed: {
			...sync('app', [
				'drawer',
				'mini',
			]),
			name: get('route/name'),
			...get('siteConfig', [
				'longTitle', 'isCloud'
			]),
			...get('auth', [
				'getCurrentUser',
			]),
			customerName() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer) { return `${user.userData.customer.name}` }
				return ''
			}
		},
		methods: {
			profile() {
				var user = this.getCurrentUser
				if (!user || !user.userData) { return }
				this.selectedUser = { id: user.userData.id }
				this.dialogUser = true
				this.$nextTick(() => {
					this.$refs.modifyProfile.prepareData()
				})
			},
			callbck_userprofile(result) {
				this.dialogUser = false
			},
		},
	}
</script>
